import { AppData } from 'src/app/data';

import { RouteFeatures } from '../routes/types';

export const getRouteFeaturesFromAppData = (
  appData: AppData
): RouteFeatures => ({
  isBitbucketLogoRefreshEnabled:
    appData.features['platform-team25-app-icon-tiles'],
  isNavigationRestructureEnabled:
    appData.features['bbc-navigation-restructure'],
  isAccountWorkspacesEnabled: appData.features.frontbucket_account_workspaces,
  isWorkspaceSettingsIndexEnabled:
    appData.features['spa-ws-settings--settings-index'],
  isNavigationResourceSwitchEnabled:
    appData.features['navigation-resource-switch'],
  isRepoAdminAliasesEnabled:
    appData.features['spa-repo-settings--username-aliases'],
  isRepoAdminComplianceEnabled:
    appData.features['spa-repo-settings--compliance'],
  isPipelinesTestManagementEnabled:
    appData.features['pipelines-test-management'],
  // eslint-disable-next-line dot-notation
  isFrontbucketDownloadsEnabled: appData.features['frontbucket_downloads'],
  isFrontbucketBranchCompareEnabled:
    appData.features.frontbucket_branch_compare,
  isFrontbucketWorkspaceMembersEnabled:
    appData.features.frontbucket_workspace_members,
  isRepoSourceFileEditEnabled:
    appData.features.frontbucket_repo_source_file_edit,
  isRepoSourceFileAnnotateEnabled:
    appData.features.frontbucket_repo_source_file_annotate,
  isRepoSourceAddFileEnabled: appData.features.frontbucket_repo_source_add_file,
  isCodeReviewerSettingsPageEnabled:
    appData.features.autoreview_repository_settings_page,
  isRepoIssuesEnabled: appData.features.frontbucket_repo_issues,
  isRepoWikiEnabled: appData.features.frontbucket_repo_wiki,
  isWorkspaceSnippetsEnabled: appData.features.frontbucket_workspace_snippets,
  isMergeQueuesEnabled: appData.features['bbc-merge-queue-enabled'],
  isClientSideLinkingEnabled: appData.features['client-side-links'],
  isPackagesUIEnabled: appData.features['use-bbc-package-ui'],
});
